module.exports = __webpack_public_path__ + "static/media/webdesktop-new.89705466.png";